<div
  [ngClass]="{
    'paysafe-form-field--focused': focused$ | async
  }"
  class="paysafe-form-field"
  dgxFormControl
>
  <div [id]="fieldId" class="paysafe-form-field__input"></div>
  <dgx-form-validity-icon />

  <div class="paysafe-form-field__overlay"></div>
</div>
